import axios from '@axios'

export default function crudActions(endpoint) {
  const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
    axios.get(`/${endpoint}`, { params: queryParams })
      .then(response => {
        commit('LIST', response.data.results)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
  const get = ({ commit }, id) => new Promise((resolve, reject) => {
    axios.get(`/${endpoint}/${id}`)
      .then(response => {
        commit('GET', response.data)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })

  const create = (ctx, data) => new Promise((resolve, reject) => {
    const params = {}
    if (data?.smsCode) {
      params.code = data.smsCode
      // eslint-disable-next-line no-param-reassign
      delete data.smsCode
    }
    axios.post(`/${endpoint}/`, data, { params })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })

  const update = (ctx, data) => new Promise((resolve, reject) => {
    const params = {}
    if (data?.smsCode) {
      params.code = data.smsCode
      // eslint-disable-next-line no-param-reassign
      delete data.smsCode
    }
    axios.put(`/${endpoint}/${data.id}/`, data, { params })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })

  const patch = (ctx, data) => new Promise((resolve, reject) => {
    const params = {}
    if (data?.smsCode) {
      params.code = data.smsCode
      // eslint-disable-next-line no-param-reassign
      delete data.smsCode
    }

    axios.patch(`/${endpoint}/${data.id}/`, data.body, { params })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })

  // eslint-disable-next-line camelcase
  const user_patch = (ctx, data) => new Promise((resolve, reject) => {
    axios.patch(`/${endpoint}/${data.id}/patch/`, data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })

  const del = (ctx, data) => new Promise((resolve, reject) => {
    const params = {}
    if (data?.smsCode) {
      params.code = data.smsCode
    }

    axios.delete(`/${endpoint}/${data.id}/`, { params })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
  return {
    list,
    get,
    create,
    update,
    patch,
    user_patch,
    del,
  }
}
